import { countryValues, countryValuesNoUS } from 'constants/enums/countries';
import { INVALID_COUNTRY } from 'constants/errors';
import { COUNTRY_FOREIGN } from 'constants/enums/locations';
import { getUniqueDuplicateValuesFromArray } from 'util/general';
import isEqual from 'lodash/isEqual';
import { BaseCustomValidator } from '../types';
import { LocationModel } from '../../models/location/types';

const countryBaseValidator: BaseCustomValidator<LocationModel['country']> = (
  validateModel,
  validate
) => function (value, options, attributeName, attributes) {
  if (validate.isEmpty(value)) { return null; } // Don't validate if there is no value

  // handle string type
  if (typeof value === 'string') {
    if (value === COUNTRY_FOREIGN) { return null; }

    if (options.excludeUnitedStates) {
      if (countryValuesNoUS.includes(value)) { return null; }
    } else if (countryValues.includes(value)) { return null; }
    return INVALID_COUNTRY;
  }

  // handle object
  if (typeof value === 'object') {
    // handle undefined value.value
    if (!value.value) { return null; }

    // handle array
    if (Array.isArray(value.value)) {
      // return if duplicate countries; can occur with xml prefill
      const duplicateCountries = getUniqueDuplicateValuesFromArray(value.value);
      if (duplicateCountries.length > 0) {
        return 'error.citizenship.duplicate';
      }

      if (options.duplicateData) {
        // Flag country entry if it matches an overlap date AND country pair provided from above
        const citizenshipItemConflict = attributes?.Dates && options.duplicateData?.some((item) => isEqual(item.Dates, attributes.Dates)
          && isEqual(item.Country?.value, value.value));

        if (citizenshipItemConflict) {
          return 'error.country.duplicate';
        }
      }

      if (options.excludeUnitedStates) {
        if (value.value.every((i) => countryValuesNoUS.includes(i))) { return null; }
      } else if (value.value.every((i) => countryValues.includes(i))) { return null; }

      return INVALID_COUNTRY;
    }

    // handle countryModel
    if (value.value === COUNTRY_FOREIGN) { return null; }
    if (options.excludeUnitedStates) {
      if (countryValuesNoUS.includes(value.value)) { return null; }
    } else if (countryValues.includes(value.value)) { return null; }

    return INVALID_COUNTRY;
  }

  return INVALID_COUNTRY;
};

export default countryBaseValidator;
